import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  useLocation,
  withRouter,
} from "react-router-dom";
import AppRoutes from "./routes";
import Headermain from "../header";
import AnimatedCursor from "react-animated-cursor";
import "./App.css";
import Preloader from "./preloader.jsx";
import { FaArrowUp } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import { Provider } from "react-redux";
import store from "../redux/store.js";

function _ScrollToTop(props) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return props.children;
}

const ScrollToTop = withRouter(_ScrollToTop);
const BackToTopButton = () => {
  const [showScroll, setShowScroll] = useState(false);
  const location = useLocation();

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, []);


  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 50) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 50) {
      setShowScroll(false);
    }
  };

  if (location.pathname === "/gallery") {
    return null;
  }

  return (
    <div
      className={`back-to-top-button ${showScroll ? "show" : ""}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <FaArrowUp />
    </div>
  );
};

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 4000,
      offset: 200,
      easing: "ease-in-out",
      delay: 5500,
      once: true,
    });

    setTimeout(() => {
      setLoading(false);
    }, 5500);
  }, []);

  return (
    <>
      <Router basename={process.env.PUBLIC_URL}>
        {/* <div className="cursor__dot">
          <AnimatedCursor
            innerSize={15}
            outerSize={15}
            color="255, 255 ,255"
            outerAlpha={0.4}
            innerScale={0.7}
            outerScale={5}
          />
        </div> */}
        <ScrollToTop>
          {loading ? (
            <Preloader />
          ) : (
            <div>
              <Headermain />
              <Provider store={store}>
                <AppRoutes />
              </Provider>
              <BackToTopButton />
            </div>
          )}
        </ScrollToTop>
      </Router>
    </>
  );
}
